export default "__VITE_ASSET__0J3B$ITu__"